module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2021-02-23 at 22.46.54.fa124f0b.jpeg";